module.exports = __webpack_public_path__ + "icon-web.svg?540bfc1bb0c1b16b048194044472f7f6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iam-icons/icon-web.svg
// module id = 19
// module chunks = 0